import { render } from "./ClosestLesson.vue?vue&type=template&id=f6996932"
import script from "./ClosestLesson.vue?vue&type=script&lang=js"
export * from "./ClosestLesson.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__